import React, { useEffect, useState, useMemo } from 'react';
import './LoadingScreen.css';

const LoadingScreen = ({ onLoadingComplete }) => {
    const [progress, setProgress] = useState(0);
    const [fadeOut, setFadeOut] = useState(false);
    const [particles, setParticles] = useState([]);

    useEffect(() => {
        // Create floating particles
        const createParticles = () => {
            const particleCount = 30;
            const newParticles = [];

            for (let i = 0; i < particleCount; i++) {
                newParticles.push({
                    id: i,
                    left: Math.random() * 100,
                    top: Math.random() * 100,
                    delay: Math.random() * 4,
                    duration: Math.random() * 3 + 3
                });
            }
            setParticles(newParticles);
        };

        createParticles();

        // Loading progress simulation
        // Increased duration to 2.5s for a slightly smoother effect if desired
        const duration = 2500;
        const interval = 20;
        const steps = duration / interval;
        const increment = 100 / steps;

        const progressInterval = setInterval(() => {
            setProgress((prev) => {
                const nextProgress = prev + increment;
                if (nextProgress >= 100) {
                    clearInterval(progressInterval);

                    // Only trigger completion once we hit >= 100%
                    setTimeout(() => {
                        setFadeOut(true);
                        setTimeout(() => {
                            onLoadingComplete();
                        }, 800);
                    }, 500); // Small pause at 100% before fading out

                    return 100;
                }
                return nextProgress;
            });
        }, interval);

        return () => {
            clearInterval(progressInterval);
        };
    }, [onLoadingComplete]);

    const particleElements = useMemo(() => (
        particles.map((particle) => (
            <div
                key={particle.id}
                className="particle"
                style={{
                    left: `${particle.left}%`,
                    top: `${particle.top}%`,
                    animationDelay: `${particle.delay}s`,
                    animationDuration: `${particle.duration}s`
                }}
            ></div>
        ))
    ), [particles]);

    return (
        <div className={`loading-screen ${fadeOut ? 'fade-out' : ''}`}>
            {/* Animated grid background */}
            <div className="grid-bg"></div>

            {/* Floating particles container */}
            <div id="particles">
                {particleElements}
            </div>

            {/* Spinner rings */}
            <div className="spinner-ring">
                <div className="ring"></div>
                <div className="ring"></div>
                <div className="ring"></div>
            </div>

            {/* Main loader */}
            <div className="loader-container">

                <div
                    className="progress-wrapper"
                    role="progressbar"
                    aria-valuenow={Math.floor(progress)}
                    aria-valuemin="0"
                    aria-valuemax="100"
                    aria-label="Loading progress"
                >
                    <div className="percentage" aria-hidden="true">{Math.floor(progress)}%</div>
                    <div className="progress-bar">
                        <div
                            className="progress-fill"
                            style={{ width: `${progress}%` }}
                        ></div>
                    </div>
                </div>

                <p className="loading-text">Loading</p>
            </div>
        </div>
    );
};

export default LoadingScreen;
